import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { P } from "../AbstractElements";
import { FooterText } from "../Utils/Constants";
import { getData } from "../CommonElements/Functions/PostGetFun";
import { API } from "../api/API";
import { ensureDexieReady, getDataFromDexie } from "../db/DexieServises";

export default function FooterLayout() {
    const [companyDetail, setCompanyDetail] = useState<any>(() => {
        try {
            const cached = localStorage.getItem("companyDetail");
            return cached ? JSON.parse(cached) : null;
        } catch {
            return null;
        }
    });

    useEffect(() => {
        let isMounted = true;

        const fetchCompanyDetails = async () => {
            try {
                let companyId =
                    localStorage.getItem("company_id") ||
                    localStorage.getItem("companyId");

                if (!companyId) {
                    try {
                        await ensureDexieReady();
                        const orgdata = await getDataFromDexie("OrgUnit");
                        if (orgdata?.[0]?.CompanyId) {
                            companyId = String(orgdata[0].CompanyId);
                        }
                    } catch (dexieErr) {
                        // ignore dexie error
                    }
                }

                const result = await getData({
                    url: API.getCompanyDetails,
                    params: companyId ? { company_id: companyId } : {},
                });

                if (result?.status === 200 || result?.data?.statusCode === 200) {
                    const resData = result.data?.data || result.data;
                    const detail = Array.isArray(resData) ? resData[0] : resData;

                    if (detail && isMounted) {
                        setCompanyDetail(detail);
                        try {
                            localStorage.setItem("companyDetail", JSON.stringify(detail));
                            const tagLine = detail?.CompanyTagLine || detail?.company_tag_line;
                            if (tagLine) {
                                localStorage.setItem("company_tagline", tagLine);
                            }
                        } catch {
                            // ignore storage write errors
                        }
                    }
                }
            } catch (err) {
                console.error("Error fetching company details for footer:", err);
            }
        };

        fetchCompanyDetails();

        return () => {
            isMounted = false;
        };
    }, []);

    const companyTagLine =
        companyDetail?.CompanyTagLine ||
        companyDetail?.company_tag_line ||
        companyDetail?.CompanyTagline ||
        localStorage.getItem("company_tagline") ||
        "With Niti, Every Move is a  Winning Move";

    return (
        <footer className="footer">
            <Container fluid>
                <Row>
                    <Col md={6} className="p-0 footer-copyright">
                        <P className="mb-0">
                            {companyTagLine}
                        </P>
                    </Col>
                    <Col md={6} className="p-0">
                        <P className="heart mb-0">
                            {FooterText}
                        </P>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}